export const toPascalCase = (input: string = ''): string => {
  let pascalCased = '';
  let capitalize = true;

  for (let i = 0; i < input.length; i++) {
    const char = input[i];
    const hasCharactersOrDigits = /[A-ZÀ-Úa-zà-ú0-9]/.test(char);

    if (!hasCharactersOrDigits) {
      capitalize = true;
      continue;
    }
    if (capitalize) {
      pascalCased += char.toUpperCase();
    } else {
      pascalCased += char.toLowerCase();
    }
    capitalize = false;
  }

  return pascalCased.normalize('NFKD').replace(/[^\w]/g, '');
};
